export default function ComparisonTable() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            他社比較
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-2xl shadow-xl overflow-hidden">
            <thead>
              <tr className="bg-slate-800">
                <th className="px-6 py-4 text-left text-white font-bold text-lg"></th>
                <th className="px-6 py-4 text-center text-white font-bold text-lg">制作会社</th>
                <th className="px-6 py-4 text-center text-white font-bold text-lg">フリーランス</th>
                <th className="px-6 py-4 text-center text-white font-bold text-lg">自作ツール</th>
                <th className="px-6 py-4 text-center bg-cyan-600 text-white font-bold text-lg">サクッとHP</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-slate-200">
                <td className="px-6 py-4 font-semibold text-slate-800">初期費用</td>
                <td className="px-6 py-4 text-center text-slate-600">30〜80万円</td>
                <td className="px-6 py-4 text-center text-slate-600">10〜30万円</td>
                <td className="px-6 py-4 text-center text-slate-600">0円</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">0円</td>
              </tr>
              <tr className="border-b border-slate-200">
                <td className="px-6 py-4 font-semibold text-slate-800">月額</td>
                <td className="px-6 py-4 text-center text-slate-600">1〜2万円</td>
                <td className="px-6 py-4 text-center text-slate-600">5千〜1万円</td>
                <td className="px-6 py-4 text-center text-slate-600">1〜3千円</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">4,980円</td>
              </tr>
              <tr className="border-b border-slate-200">
                <td className="px-6 py-4 font-semibold text-slate-800">デザイン</td>
                <td className="px-6 py-4 text-center text-slate-600">◎ 高い</td>
                <td className="px-6 py-4 text-center text-slate-600">○ 人による</td>
                <td className="px-6 py-4 text-center text-slate-600">△ 自分次第</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">○ プロ制作</td>
              </tr>
              <tr className="border-b border-slate-200">
                <td className="px-6 py-4 font-semibold text-slate-800">制作期間</td>
                <td className="px-6 py-4 text-center text-slate-600">1〜3ヶ月</td>
                <td className="px-6 py-4 text-center text-slate-600">2週〜1ヶ月</td>
                <td className="px-6 py-4 text-center text-slate-600">自分次第</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">最短1週間</td>
              </tr>
              <tr className="border-b border-slate-200">
                <td className="px-6 py-4 font-semibold text-slate-800">コード所有</td>
                <td className="px-6 py-4 text-center text-slate-600">× なし</td>
                <td className="px-6 py-4 text-center text-slate-600">△ 要交渉</td>
                <td className="px-6 py-4 text-center text-slate-600">× PF依存</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">◎ 譲渡あり</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-semibold text-slate-800">手間</td>
                <td className="px-6 py-4 text-center text-slate-600">◎ おまかせ</td>
                <td className="px-6 py-4 text-center text-slate-600">○ ほぼお任せ</td>
                <td className="px-6 py-4 text-center text-slate-600">× 全部自分</td>
                <td className="px-6 py-4 text-center bg-cyan-50 font-bold text-cyan-700">◎ おまかせ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}